<template>
  <div class="flex-page">
    <a-form class="ctrl" layout="inline">
      <a-form-item label="用户组">
        <a-select style="width: 100px" v-model="options.group_id">
          <a-select-option :value="0">全部</a-select-option>
          <a-select-option v-for="(group, index) in groupList" :key="index" :value="group.id">{{group.group_name}}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="姓名">
        <a-input style="width: 200px" placeholder="请输入姓名" v-model="options.name"></a-input>
      </a-form-item>

      <a-form-item>
        <a-button type="primary" @click="search">搜索</a-button>
      </a-form-item>
    </a-form>

    <div class="statistics">共{{page.amount}}个</div>
    
    <a-table class="main" size="small" :rowKey="(record) => record.id" bordered :columns="columns"
      :data-source="list" :pagination="false">
      <template slot="zhuangtai" slot-scope="text, record">
        <a-tag v-if="record.status == 1" color="green">正常</a-tag>
        <a-tag v-if="record.status == 0" color="red">已删除</a-tag>
      </template>
      <template slot="action" slot-scope="text, record">
        <span>
          <a href="javascript:;" @click="showView(record)">编辑</a>
        </span>
        <a-divider type="vertical" />

        <a-popconfirm v-if="record.status == 1" title="确定删除吗？" ok-text="确定" cancel-text="取消"
          @confirm="doStatus(record.id, 0)">
          <a href="javascript:;">删除</a>
        </a-popconfirm>

        <a-popconfirm v-if="record.status == 0" title="确定恢复吗？" ok-text="确定" cancel-text="取消"
          @confirm="doStatus(record.id, 1)">
          <a>恢复</a>
        </a-popconfirm>
        <a-divider type="vertical" />
      </template>
    </a-table>

    <a-pagination class="pagination" showQuickJumper v-model="page.now_page" :defaultPageSize="page.page_size"
      :total="page.amount" @change="changePage" />

    <a-modal v-model="view_data.show" title="编辑用户" @ok="doEditUser" @cancel="cancelEditUser">
      <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
        <a-form-item label="姓名">
          <a-input style="width: 200px" v-model="view_data.name" placeholder="请输入姓名"></a-input>
          <i class="must">*</i>
        </a-form-item>
        <a-form-item label="密码">
          <a-input style="width: 200px" v-model="view_data.password" placeholder="请输入密码"></a-input>
        </a-form-item>
        <a-form-item label="职位">
          <a-input style="width: 200px" v-model="view_data.position" placeholder="请输入职位"></a-input>
          <i class="must">*</i>
        </a-form-item>
        <a-form-item label="权限">
          <a-select style="width: 150px" v-model="view_data.group">
            <a-select-option :value="0">请选择</a-select-option>
            <a-select-option v-for="(group, index) in groupList" :key="index" :value="group.id">{{group.name}}
            </a-select-option>
          </a-select>
          <i class="must">*</i>
        </a-form-item>
        <a-form-item label="手机号">
          <a-input style="width: 200px" v-model="view_data.mobile" placeholder="请输入手机号"></a-input>
          <i class="must">*</i>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
const columns = [
  {
    title: "序号",
    dataIndex: "id",
  },
  {
    title: "姓名",
    dataIndex: "name",
  },
  {
    title: "权限",
    dataIndex: "group_name",
  },
  {
    title: "电话",
    dataIndex: "tel",
  },
  {
    title: "手机",
    dataIndex: "mobile",
  },
  {
    title: "添加时间",
    dataIndex: "created_at",
  },
  {
    title: "状态",
    scopedSlots: { customRender: "zhuangtai" },
  },
  {
    title: "操作",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export default {
  data() {
    return {
      columns,
      list: [],
      options: {
        name: "",
        group_id: 0
      },
      page: {
        now_page: 1,
        page_size: 50,
        amount: 0,
      },
      view_data: {
        show: false,
      },
      groupList: [],
    };
  },
  created() {
    this.getGroupList()
    this.getList();
  },
  methods: {
    async getGroupList() {
      const r = await this.$axios.get("/user/getGroupList");

      if(r.status == 1){
        this.groupList = r.list;
      }
    },

    search() {
      this.page.now_page = 1;
      this.getList();
    },
    changePage(e) {
      this.page.now_page = e;
      this.getList();
    },
    
    async getList() {
      const options = { ...this.options };
      options.page = this.page.now_page;
      const r = await this.$axios.get("/user/getList", {
        params: options
      });
      console.log(r);

      this.list = r.list;
      this.page.amount = r.amount;
    },
    async doStatus(id, status) {
      const r = await this.$axios.post("/changeUserStatus", {
        id: id,
        status: status,
      });
      if (r.status == 1) {
        this.$message.success("操作成功");
        this.getList();
      } else {
        this.$message.error("操作失败");
      }
    },
    showView(record) {
      this.view_data = {
        show: true,
        id: record.id,
        name: record.name,
        password: '',
        position: record.position,
        group: record.group,
        mobile: record.mobile,
      };
    },
    async doEditUser() {
      const that = this;
      if(!this.view_data.name) return this.$message.error('请输入姓名')
      if(!this.view_data.position) return this.$message.error('请输入职位')
      if(!this.view_data.group) return this.$message.error('请选择权限')
      if(!this.view_data.mobile) return this.$message.error('请输入手机号码')
      const r = await this.$axios.post('/editUser', this.view_data);
      if(r.status == 1) {
        this.$message.success(r.msg);
        this.cancelEditUser();
        this.getList()
      }else{
        this.$message.error(r.msg)
      }
    },
    cancelEditUser() {
      this.view_data = {
        show: false,
      };
    },
  },
};
</script>